(function () {
  function initHeader() {
    var shell = document.querySelector('[data-leile-header]');
    if (!shell || shell.dataset.ready) return;
    shell.dataset.ready = 'true';
    var open = document.querySelector('[data-menu-open]');
    var close = document.querySelector('[data-menu-close]');
    var overlay = document.querySelector('[data-menu-overlay]');
    var menu = document.querySelector('[data-mobile-menu]');
    var toggleMenu = function (state) {
      document.body.classList.toggle('leile-menu-open', state);
      open && open.setAttribute('aria-expanded', String(state));
      menu && menu.setAttribute('aria-hidden', String(!state));
    };
    open && open.addEventListener('click', function () { toggleMenu(true); });
    close && close.addEventListener('click', function () { toggleMenu(false); });
    overlay && overlay.addEventListener('click', function () { toggleMenu(false); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') toggleMenu(false); });
    var updateSticky = function () {
      shell.classList.toggle('is-sticky', shell.dataset.sticky === 'true' && window.scrollY > 34);
    };
    updateSticky();
    window.addEventListener('scroll', updateSticky, { passive: true });
    document.addEventListener('leile:slidechange', function (event) {
      if (shell.dataset.home === 'true' && !shell.classList.contains('is-sticky')) {
        shell.dataset.tone = event.detail.tone || 'white';
      }
    });
  }

  function initCarousel(carousel) {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-carousel-dot]'));
    var previous = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    var index = 0;
    var timer;
    var delay = Number(carousel.dataset.delay) || 6000;
    var duration = Number(carousel.dataset.duration) || 900;
    var autoplay = carousel.dataset.autoplay === 'true';
    if (slides.length < 2) return;

    function announce() {
      document.dispatchEvent(new CustomEvent('leile:slidechange', { detail: { tone: slides[index].dataset.headerTone } }));
    }
    function show(target, direction) {
      if (target === index) return;
      var old = slides[index];
      old.classList.remove('is-active');
      old.classList.add(direction > 0 ? 'is-leaving-left' : 'is-leaving-right');
      old.setAttribute('aria-hidden', 'true');
      index = (target + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      slides[index].setAttribute('aria-hidden', 'false');
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
      window.setTimeout(function () { old.classList.remove('is-leaving-left', 'is-leaving-right'); }, duration + 50);
      announce();
      restart();
    }
    function restart() {
      window.clearInterval(timer);
      if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = window.setInterval(function () { show(index + 1, 1); }, delay);
      }
    }
    previous && previous.addEventListener('click', function () { show(index - 1, -1); });
    next && next.addEventListener('click', function () { show(index + 1, 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i, i > index ? 1 : -1); }); });
    carousel.addEventListener('mouseenter', function () { window.clearInterval(timer); });
    carousel.addEventListener('mouseleave', restart);
    carousel.addEventListener('focusin', function () { window.clearInterval(timer); });
    carousel.addEventListener('focusout', restart);
    var startX = 0;
    carousel.addEventListener('touchstart', function (event) { startX = event.changedTouches[0].clientX; }, { passive: true });
    carousel.addEventListener('touchend', function (event) {
      var delta = event.changedTouches[0].clientX - startX;
      if (Math.abs(delta) > 50) show(index + (delta < 0 ? 1 : -1), delta < 0 ? 1 : -1);
    }, { passive: true });
    announce();
    restart();
  }

  function init3DModal(modal) {
    if (modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    var id = modal.id;
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-leile-3d-open="' + id + '"]'));
    var closers = Array.prototype.slice.call(modal.querySelectorAll('[data-leile-3d-close]'));
    var dialog = modal.querySelector('.leile-3d-modal__dialog');
    var viewer = modal.querySelector('[data-leile-model-viewer]');
    var lastOpener = null;

    function loadViewer() {
      if (!viewer || viewer.getAttribute('src')) return;
      viewer.setAttribute('src', viewer.dataset.modelSrc);

      // The hero owns its model-viewer runtime. Shopify's product-page feature
      // loader is not guaranteed to register <model-viewer> on the homepage.
      if (window.customElements && !customElements.get('model-viewer')) {
        customElements.whenDefined('model-viewer').then(function () {
          // Re-assign after the custom element upgrades so it starts loading
          // immediately in browsers that created the element before the module.
          viewer.setAttribute('src', viewer.dataset.modelSrc);
        });
      }
    }

    function openModal(opener) {
      lastOpener = opener || document.activeElement;
      loadViewer();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('leile-3d-modal-open');
      window.setTimeout(function () { dialog && dialog.focus(); }, 40);
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('leile-3d-modal-open');
      if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () { openModal(opener); });
    });
    closers.forEach(function (closer) { closer.addEventListener('click', closeModal); });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  function init() {
    initHeader();
    document.querySelectorAll('[data-leile-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-leile-3d-modal]').forEach(init3DModal);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
